import { type WidgetProps } from '../../../../types/WidgetProps';
import { getDefaultShippingOption } from './getDefaultShippingOption';
import { getShippingOptions } from './getShippingOptions';

interface GetShippingPaymentRequestDataParams {
  requestShipping: boolean;
  locale: string;
  currency: string;
  shippingMethods: WidgetProps['shippingMethods'];
}
interface GetShippingPaymentRequestDataReturn {
  shippingAddressRequired: google.payments.api.PaymentDataRequest['shippingAddressRequired'];
  shippingAddressParameters?: google.payments.api.PaymentDataRequest['shippingAddressParameters'];
  shippingOptionRequired: google.payments.api.PaymentDataRequest['shippingOptionRequired'];
  shippingOptionParameters?: google.payments.api.PaymentDataRequest['shippingOptionParameters'];
}

export const getShippingPaymentRequestData = ({
  requestShipping,
  locale,
  currency,
  shippingMethods,
}: GetShippingPaymentRequestDataParams): GetShippingPaymentRequestDataReturn => {
  const requestShippingOption = requestShipping;

  const options: GetShippingPaymentRequestDataReturn = {
    shippingOptionRequired: requestShippingOption,
    shippingAddressRequired: requestShipping,
  };

  if (options.shippingOptionRequired) {
    const shippingOptions = getShippingOptions({
      shippingMethods,
      currencyCode: currency,
      locale,
      isRequired: options.shippingOptionRequired,
    });
    options.shippingOptionParameters = {
      shippingOptions,
      defaultSelectedOptionId: getDefaultShippingOption(shippingOptions)?.id,
    };
  }

  if (options.shippingAddressRequired) {
    options.shippingAddressParameters = {
      allowedCountryCodes: undefined,
      phoneNumberRequired: true,
    };
  }

  return options;
};
